import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Store } from '../../containers/my_sessions/types';

interface productDetails {
    productUrls: string[];
}
interface IWidgetState {
    isAppInWidgetMode: boolean;
    store: null | Store;
    sourceUrl: null | string;
    selectedQuestion: null | string;
    isOpened: null | boolean;
    productDetails: productDetails;
    searchGender: null | string;
}
export const initialState: IWidgetState = {
    isAppInWidgetMode: false,
    store: null,
    sourceUrl: null,
    selectedQuestion: null,
    isOpened: null,
    productDetails: { productUrls: [] },
    searchGender: null,
};

const widgetSlice = createSlice({
    name: 'widget',
    initialState,
    reducers: {
        setIsAppInWidgetMode: (state, action: PayloadAction<boolean>) => {
            state.isAppInWidgetMode = action.payload;
        },
        setWidgetStore: (state, action: PayloadAction<Store>) => {
            state.store = action.payload;
        },
        setSourceUrl: (state, action: PayloadAction<string | null>) => {
            state.sourceUrl = action.payload;
        },
        setSelectedQuestion: (state, action: PayloadAction<string | null>) => {
            state.selectedQuestion = action.payload;
        },
        setWidgetOpenState: (state, action: PayloadAction<boolean>) => {
            state.isOpened = action.payload;
        },
        setProductDetails: (state, action: PayloadAction<productDetails>) => {
            state.productDetails = action.payload;
        },
        setSearchGender: (state, action: PayloadAction<string | null>) => {
            state.searchGender = action.payload;
        },
    },
});

export const {
    setIsAppInWidgetMode,
    setWidgetStore,
    setSourceUrl,
    setSelectedQuestion,
    setWidgetOpenState,
    setProductDetails,
    setSearchGender,
} = widgetSlice.actions;

const widgetReducer = widgetSlice.reducer;
export default widgetReducer;
